import { inject, Injectable } from '@angular/core';
import { UrlTree, Router, ActivatedRouteSnapshot } from '@angular/router';
import { StackedMessagesService } from '@shared/stacked-messages/stacked-messages.service';
import { CommonsFacade } from '@state/commons';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable()
export class ProcessesGuard {
  private readonly router = inject(Router);
  private readonly commonsFacade = inject(CommonsFacade);
  private readonly notifService = inject(StackedMessagesService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const exitUrlTree = this.router.createUrlTree(['/']);
    return this.commonsFacade.getListOfAvailableProcesses$().pipe(
      take(1),
      map(processes => {
        if (!processes?.length) {
          this.notifService.showError({ message: 'MISSING_AVAILABLE_PROCESSES' });
          return exitUrlTree;
        }
        return true;
      })
    );
  }
}
